import { CRUISE_CHECKOUT_INFLOW } from 'constants/checkout'

export function getIsInFlowStep(stepId: string): boolean {
  return ['cruises', 'cabin-location'].includes(stepId)
}

export function getIsCabinRateStep(stepId: string): boolean {
  return stepId === 'cruises'
}

export function getCheckoutRouteFromURL(pathname: string): string {
  const split = pathname.split('/').pop() || ''
  return split?.split('?')[0]
}

export function getCruiseCheckoutStep(item: App.Checkout.CruiseItem): string {
  if (item.cabinNumber) return CRUISE_CHECKOUT_INFLOW.PURCHASE
  if (item.componentId) return CRUISE_CHECKOUT_INFLOW.CABIN_LOCATION
  if (item.cabinCode || item.bookingId) return CRUISE_CHECKOUT_INFLOW.CABIN_TYPE
  return CRUISE_CHECKOUT_INFLOW.TRAVELERS
}
